"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactBootstrap = require("react-bootstrap");

var _colors = require("../../../config/colors");

var _config = require("../../../config/config");

var Prefill = function Prefill(_ref) {
  var prefill = _ref.prefill,
      selectOptions = _ref.selectOptions,
      onChange = _ref.onChange;

  var handlePrefill = function handlePrefill(e) {
    onChange(e.target.name, e.target.value);
  };

  return (
    /*#__PURE__*/
    _react["default"].createElement(_reactBootstrap.Form.Group, {
      controlId: "PrefillControl"
    },
    /*#__PURE__*/
    _react["default"].createElement(_reactBootstrap.Form.Label, {
      style: {
        marginBottom: _config.SIDEBAR_INPUTS_MARGIN,
        fontWeight: 300,
        fontSize: 14,
        color: selectOptions.length > 0 ? '' : 'rgb(155, 155, 155)'
      }
    }, "Prefill Data"),
    /*#__PURE__*/
    _react["default"].createElement("div", {
      className: "select-wrapper"
    }, selectOptions.length > 0 ?
    /*#__PURE__*/
    _react["default"].createElement(_reactBootstrap.Form.Control, {
      as: "select",
      name: "prefill",
      onChange: handlePrefill,
      value: prefill || '',
      style: {
        color: prefill ? _colors.SELECT_INPUT_COLOR : _colors.PLACE_HOLDER_COLOR,
        backgroundColor: _colors.SIDEBAR_INPUTS_BACKGROUND_COLOR,
        fontWeight: 300,
        fontSize: 14
      }
    },
    /*#__PURE__*/
    _react["default"].createElement("option", {
      value: "",
      style: {
        color: _colors.PLACE_HOLDER_COLOR
      }
    }, "Select"), selectOptions.map(function (value) {
      return (
        /*#__PURE__*/
        _react["default"].createElement("option", {
          value: value[1],
          key: value[1],
          style: {
            color: _colors.SELECT_INPUT_COLOR
          }
        }, value[0])
      );
    })) :
    /*#__PURE__*/
    _react["default"].createElement(_reactBootstrap.Form.Control, {
      as: "select",
      name: "prefill",
      style: {
        color: prefill ? _colors.SELECT_INPUT_COLOR : _colors.PLACE_HOLDER_COLOR,
        backgroundColor: _colors.SIDEBAR_INPUTS_BACKGROUND_COLOR,
        fontWeight: 300,
        fontSize: 14
      },
      disabled: true
    },
    /*#__PURE__*/
    _react["default"].createElement("option", {
      value: "Not Available",
      style: {
        color: _colors.SELECT_INPUT_COLOR
      }
    }, "Not Available"))))
  );
};

Prefill.defaultProps = {
  prefill: '',
  selectOptions: []
};
Prefill.propTypes = process.env.NODE_ENV !== "production" ? {
  prefill: _propTypes["default"].string,
  // eslint-disable-next-line react/forbid-prop-types
  selectOptions: _propTypes["default"].arrayOf(_propTypes["default"].array),
  onChange: _propTypes["default"].func.isRequired
} : {};

var _default = exports["default"] = Prefill;